// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Dhg4Q","left":"styles_left__9YHck","right":"styles_right__80p01"};